const API_BASE = '/api/v1/public/projects';
const VSJ_SLUG = 'valor-san-juan';

export interface GeocodeResultDto {
  label: string;
  address: string;
  neighborhood: string;
  city: string;
  lat: number;
  lng: number;
  source: string;
}

export interface GeocodeResponseDto {
  results: GeocodeResultDto[];
}

export async function fetchGeocodeSuggestions(
  query: string,
  signal?: AbortSignal,
): Promise<GeocodeResponseDto> {
  const res = await fetch(
    `${API_BASE}/${VSJ_SLUG}/geocode?q=${encodeURIComponent(query)}`,
    { signal },
  );
  if (!res.ok) throw new Error(`geocode: HTTP ${res.status}`);
  return res.json() as Promise<GeocodeResponseDto>;
}
